import React, { Component } from 'react';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { DataTable } from 'primereact/datatable';
import { CSVLink, CSVDownload } from "react-csv";
import { Calendar } from 'primereact/calendar';
import tableRequest from '../../models/tableRequest.js';
import DispatchReportService from '../../services/DispatchReportService';
import DispatchService from '../../services/DispatchService';
import { InputText } from 'primereact/inputtext';
import { Column } from 'primereact/column';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import MessageComponent from '../../template/Message';
import Loaders from '../../template/Loaders';
import $ from 'jquery';
import PrintDispatchService from '../../services/PrintDispatchService';
import { Button } from 'primereact/button';

export default class StockReport extends Component {
    constructor(props) {
        super(props);
        this.DispatchReportService = new DispatchReportService();
        this.DispatchService = new DispatchService();
        this.PrintDispatchService = new PrintDispatchService();
        this.tblResponse = new tableRequest();
        this.state = {
            FromDate: new Date(),
            ToDate: new Date(),
            success: false,
            updateLoader: false,
            visible: false,
            sortOrder: '',
            sales: [],
            loading: true,
            first: 0,
            rows: 10,
            totalRecords: 0,
            globalFilter: null,
            emptyMessage: 'No Data found',
            allData: [],
            refId: '',
            depotId: ''
        }
        this.onPage = this.onPage.bind(this);
        this.FilterData = this.FilterData.bind(this);
        this.searchFilter = this.searchFilter.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.actionTemplate = this.actionTemplate.bind(this);
        this.actionTemplate1 = this.actionTemplate1.bind(this);
        this.onSort = this.onSort.bind(this);
        this.GetReportExport = this.GetReportExport.bind(this);
    }

    // Format date to dd-mm-yyyy for display only
    formatDateForDisplay(date) {
        if (!date) return '';
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    }

    //to trigger api function o page call componentDidMount() {
    componentDidMount() {
        setTimeout(() => {
            var date = new Date();
            date.setDate(date.getDate() - 7);
            // Send dates in original format (as before)
            this.tblResponse.FromDate = date.toLocaleDateString();
            this.tblResponse.ToDate = new Date().toLocaleDateString();
            this.tblResponse.PageSize = this.state.rows;   // 10
        this.tblResponse.PageNo = 1;
            this.setState({ FromDate: date, ToDate: new Date() });
            this.GetDispatch();
        }, 1000);

        $('.p-column-title').on('click', function () {
            $(this).next().removeClass('pi-sort').toggleClass('pi-sort-up').addClass('pi-sort-down');
        });
    }

    //to search data
    searchFilter(e) {
        this.setState({ loading: true, updateLoader: true });
        this.tblResponse.SearchValue = e.target.value;
        this.GetDispatch();
    }

    onChange = date => this.setState({ FromDate: '', ToDate: '' })

    // Export detailed summary of all reference IDs
    GetReportExport() {
        this.setState({ updateLoader: true });
        
        // Get all reference IDs from the current filtered data
        const allReferenceIds = this.state.sales.map(item => item.ReferenceId);
        
        if (allReferenceIds.length === 0) {
            this.refs.Messchild.showError("No data available to export.");
            this.setState({ updateLoader: false });
            return;
        }

        // Create an array to store all detailed data
        let allDetailedData = [];
        
        // Fetch detailed report for each reference ID
        let promises = allReferenceIds.map(refId => {
            return this.DispatchReportService.GetStocktoExcel(refId).then(data => {
                if (data.data && data.data.ResponseData && data.data.ResponseData.length > 0) {
                    // Add reference ID to each record for identification
                    const detailedData = data.data.ResponseData.map(item => ({
                        ...item,
                        'Main Reference ID': refId
                    }));
                    return detailedData;
                }
                return [];
            }).catch(error => {
                console.error(`Error fetching data for Ref ID ${refId}:`, error);
                return [];
            });
        });

        Promise.all(promises).then(results => {
            results.forEach(result => {
                if (result.length > 0) {
                    allDetailedData.push(...result);
                }
            });
            
            if (allDetailedData.length > 0) {
                // Create worksheet from combined detailed data
                const worksheet = XLSX.utils.json_to_sheet(allDetailedData);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Detailed Summary Report');
                
                // Auto-size columns
                const maxWidth = 20;
                const wscols = [];
                for (let i = 0; i < 20; i++) {
                    wscols.push({ wch: maxWidth });
                }
                worksheet['!cols'] = wscols;
                
                const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                const excelBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
                const fileName = `Detailed_Summary_Report_${this.formatDateForDisplay(new Date())}.xlsx`;
                saveAs(excelBlob, fileName);
                this.refs.Messchild.showSuccess("Report exported successfully!");
            } else {
                this.refs.Messchild.showError("No detailed data available for the selected records.");
            }
            this.setState({ updateLoader: false });
        }).catch(error => {
            console.error('Error fetching detailed data:', error);
            this.refs.Messchild.showError("Error generating detailed summary report.");
            this.setState({ updateLoader: false });
        });
    }

    //on page loading
    onPage(event) {
        this.setState({ loading: true, updateLoader: true });
        this.getLazyLoadingValues(event);
        this.GetDispatch();
    }

    // call every change of form and validation part also
    handleChange(event) {
        const { name, value } = event.target;
        
        switch (name) {
            case 'FromDate':
                if (value == null || !(value instanceof Date)) {
                    this.formIsValid = false;
                    this.refs.Messchild.showError("Please select from date.");
                    return;
                } else if ((value instanceof Date) && (this.state.ToDate instanceof Date)) {
                    const startDate = value;
                    const endDate = this.state.ToDate;
                    if (!(Date.parse(startDate) <= Date.parse(endDate))) {
                        this.formIsValid = false;
                        this.refs.Messchild.showError("From date must be less than to date.");
                        return;
                    }
                }
                break;
            case 'ToDate':
                if (value == null || !(value instanceof Date)) {
                    this.formIsValid = false;
                    this.refs.Messchild.showError("Please select to date.");
                    return;
                } else if ((value instanceof Date) && (this.state.FromDate instanceof Date)) {
                    const startDate = this.state.FromDate;
                    const endDate = value;
                    if (!(Date.parse(startDate) <= Date.parse(endDate))) {
                        this.formIsValid = false;
                        this.refs.Messchild.showError("To date must be greater than from date.");
                        return;
                    }
                }
                break;
            default:
                break;
        }
        this.setState({ [name]: value });
    }

    //to filter data
    FilterData() {
        this.setState({ loading: true, updateLoader: true });
        // Send dates in original format
        this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString();
        this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString();
        this.GetDispatch();
    }

    getLazyLoadingValues(event) {
        this.tblResponse.PageSize = event.rows;
      this.tblResponse.PageNo = (event.first / event.rows) + 1;
        this.tblResponse.IsActive = '1';
        this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
        this.tblResponse.SortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
        // Send dates in original format
        this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString();
        this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString();
    }

    //to get dispatch data
    GetDispatch() {
        debugger
        this.tblResponse.SortColumn = '';
       
        this.DispatchReportService.GetStockInReport(this.tblResponse).then(data => {
            const resdata = data.data;
            
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
                // Extract Ref ID and Depot ID from first record if available
                if (resdata.ResponseData[0].ReferenceId) {
                    this.setState({ refId: resdata.ResponseData[0].ReferenceId });
                }
                if (resdata.ResponseData[0].DepotId) {
                    this.setState({ depotId: resdata.ResponseData[0].DepotId });
                }
                
                this.datasource = resdata.ResponseData;
                this.setState({ 
                    totalRecords: resdata.ResponseData[0].TotalRows, 
                    first: (this.tblResponse.PageNo - 1) * this.tblResponse.PageSize,
                    sales: this.datasource.slice(0, this.tblResponse.PageSize), 
                    loading: false,
                    updateLoader: false
                });
            } else {
                this.datasource = null;
                this.setState({ 
                    totalRecords: 0, 
                    first: 0, 
                    sales: [], 
                    loading: false,
                    updateLoader: false
                });
            }
        }).catch(error => {
            console.error('Error fetching data:', error);
            this.setState({ 
                loading: false, 
                updateLoader: false,
                sales: [],
                totalRecords: 0
            });
            this.refs.Messchild.showError("Error fetching report data.");
        });
    }

    //for sorting
    onSort(event) {
        this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1, loading: true, updateLoader: true });
        const sortField = event.sortField == "CreatedDt" ? "CreatedDt" : event.sortField;
        this.tblResponse.SortColumn = sortField ? sortField : "";
        this.tblResponse.SortOrder = this.state.sortOrder === 1 ? 'DESC' : 'ASC';
        this.GetDispatch();
    }

    actionTemplate(rowData, column) {
        const editMode = (e) => {
            e.preventDefault();
            this.setState({ updateLoader: true });
            this.DispatchReportService.GetStocktoExcel(rowData.ReferenceId).then(data => {
                const resdata = data.data.ResponseData;
                const worksheet = XLSX.utils.json_to_sheet(resdata);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Stock Report');
                const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                const excelBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
                const fileName = `Stock Report Details-${rowData.ReferenceId}-${rowData.Warehouse || 'NA'}.xlsx`;
                saveAs(excelBlob, fileName);
                this.setState({ updateLoader: false });
                this.refs.Messchild.showSuccess("Detailed report downloaded successfully!");
            }).catch(error => {
                console.error('Error fetching data:', error);
                this.refs.Messchild.showError("Error generating detailed report.");
                this.setState({ updateLoader: false });
            });
        };

        return <span>
            <Button type="button" icon="pi pi-print" onClick={editMode} className="p-button-warning" style={{ marginRight: '3px' }}></Button>
        </span>;
    }

    actionTemplate1(rowData, column) {
        const editMode1 = (e) => {
            e.preventDefault();
            this.setState({ updateLoader: true });
            this.DispatchReportService.GetStocktoExcelSummary(rowData.ReferenceId).then(data => {
                const resdata = data.data.ResponseData;
                const worksheet = XLSX.utils.json_to_sheet(resdata);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Stock Report');
                const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                const excelBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
                const fileName = `Stock Report Summary-${rowData.ReferenceId}-${rowData.Warehouse || 'NA'}.xlsx`;
                saveAs(excelBlob, fileName);
                this.setState({ updateLoader: false });
                this.refs.Messchild.showSuccess("Summary report downloaded successfully!");
            }).catch(error => {
                console.error('Error fetching data:', error);
                this.refs.Messchild.showError("Error generating summary report.");
                this.setState({ updateLoader: false });
            });
        };

        return <span>
            <Button type="button" icon="pi pi-print" onClick={editMode1} className="p-button-warning" style={{ marginRight: '3px' }}></Button>
        </span>;
    }

    //to render html part
    render() {
        let header = (
            <div className="row">
                <div className="col-md-8">
                    <form className="form-inline">
                        <div className="form-group mr-2">
                            <Calendar 
                                value={this.state.FromDate} 
                                name="FromDate" 
                                onChange={this.handleChange} 
                                appendTo={document.getElementById('root')} 
                                placeholder="From Date" 
                                dateFormat="dd-mm-yy"
                            />
                        </div>
                        <div className="form-group">
                            <Calendar 
                                value={this.state.ToDate} 
                                name="ToDate" 
                                onChange={this.handleChange} 
                                appendTo={document.getElementById('root')} 
                                placeholder="To Date" 
                                dateFormat="dd-mm-yy"
                            />
                        </div>
                        <button type="button" onClick={this.FilterData} className="btn btn-primary ml-3">Submit</button>
                    </form>
                </div>
                <div className="text-right col-md-4">
                    <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>
                    <InputText type="search" onInput={this.searchFilter} placeholder="Global Search" size="22" />
                    <button className="btn btn-primary ml-2" disabled={!this.state.sales || this.state.sales.length === 0} onClick={this.GetReportExport}>
                        Export Detailed Summary
                    </button>
                </div>
            </div>
        );

        return (
            <>
                <MessageComponent ref="Messchild" />
                {this.state.updateLoader && <Loaders loader={this.state.updateLoader} />}
                <div className="heading">
                    <h1>Stock-In Report</h1>
                </div>
                <div className="text-muted mb-2">
                    <small>Total Records: {this.state.totalRecords} | Page Size: {this.state.rows}</small>
                </div>
                <DataTable 
                    exportFilename="Dispatch Report" 
                    style={{ width: '100%' }} 
                    scrollable 
                    responsive={true} 
                    header={header} 
                    globalFilter={this.state.globalFilter} 
                    emptyMessage={this.state.emptyMessage} 
                    value={this.state.sales} 
                    sortMode="multiple" 
                    paginator={true} 
                    className="tblAuto" 
                    rows={this.state.rows} 
                    rowsPerPageOptions={[10, 20, 50]}
                    totalRecords={this.state.totalRecords} 
                    lazy={true} 
                    first={this.state.first} 
                    onPage={this.onPage} 
                    onSort={this.onSort} 
                    ref={(el) => { this.dt = el; }}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    loading={this.state.loading}
                >
                    <Column field="ReferenceId" headerStyle={{ width: '200px' }} header="Reference Id" sortable={true} />
                    <Column field="Warehouse" headerStyle={{ width: '220px' }} header="Warehouse" sortable={true} />
                    <Column field="SubmittedBy" headerStyle={{ width: '200px' }} header="Submitted By" sortable={true} />
                    <Column field="Qty" headerStyle={{ width: '150px' }} header="Quantity" sortable={true} />
                    <Column 
                        field="SubmitDate" 
                        headerStyle={{ width: '150px' }} 
                        header="Submit Date" 
                        sortable={true}
                        body={(rowData) => this.formatDateForDisplay(rowData.SubmitDate)}
                    />
                    <Column body={this.actionTemplate} headerStyle={{ width: '150px' }} header="Detailed Report" />
                    <Column body={this.actionTemplate1} headerStyle={{ width: '150px' }} header="Summary Report" />
                </DataTable>
            </>
        )
    }
}